import * as React from 'react';
import PropTypes from 'prop-types';
import SvgContainer from './SvgContainer';

export const defaultSvgIconProps = {
  size: 'medium',
  color: '#1E1D1C'
};

export const HyriaIcon = ({ size, color }) => {
  return (
    <SvgContainer size={size}>
      <svg
        width="66"
        height="49"
        viewBox="0 0 66 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.5461 33.9345L46.1214 46.516C46.2371 46.631 46.3936 46.6955 46.5567 46.6955C46.7198 46.6955 46.8762 46.631 46.9919 46.516L52.1899 41.318C52.3049 41.2023 52.3694 41.0458 52.3694 40.8828C52.3694 40.7197 52.3049 40.5632 52.1899 40.4475L47.3376 35.5952C47.2226 35.4795 47.1581 35.3231 47.1581 35.16C47.1581 34.9969 47.2226 34.8404 47.3376 34.7247L51.7948 30.2613C51.8522 30.2035 51.9205 30.1576 51.9957 30.1262C52.0709 30.0949 52.1516 30.0788 52.2331 30.0788C52.3146 30.0788 52.3953 30.0949 52.4705 30.1262C52.5458 30.1576 52.6141 30.2035 52.6714 30.2613L57.5238 35.1137C57.6394 35.2287 57.7959 35.2932 57.959 35.2932C58.1221 35.2932 58.2786 35.2287 58.3942 35.1137L63.5799 29.928C63.6378 29.8706 63.6837 29.8023 63.715 29.7271C63.7464 29.6519 63.7625 29.5712 63.7625 29.4897C63.7625 29.4082 63.7464 29.3275 63.715 29.2523C63.6837 29.177 63.6378 29.1087 63.5799 29.0514L51.0046 16.4761"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
        />
        <path
          d="M40.5223 18.1182L45.813 23.4088C45.9279 23.5245 45.9925 23.6809 45.9925 23.844C45.9925 24.0071 45.9279 24.1636 45.813 24.2792L41.3496 28.7426C41.2339 28.8576 41.0774 28.9222 40.9143 28.9222C40.7512 28.9222 40.5948 28.8576 40.4791 28.7426L35.1885 23.4397"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M27.1875 40.2932V10.778C27.1875 10.6143 27.2525 10.4572 27.3683 10.3415C27.4841 10.2257 27.6411 10.1606 27.8048 10.1606H57.3015"
          stroke={color}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M27.1877 17.1118C25.7707 18.0308 24.1169 18.5177 22.428 18.5132"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M30.3607 14.6981C31.1142 14.6981 31.725 14.0873 31.725 13.3338C31.725 12.5803 31.1142 11.9695 30.3607 11.9695C29.6072 11.9695 28.9963 12.5803 28.9963 13.3338C28.9963 14.0873 29.6072 14.6981 30.3607 14.6981Z"
          fill={color}
        />
        <path
          d="M9.29083 43.8677C9.27273 43.9371 9.22849 43.9968 9.16735 44.0343L5.04968 46.6457C5.01696 46.6677 4.98001 46.6827 4.94119 46.6897C4.90236 46.6966 4.86251 46.6954 4.82418 46.6861C4.78585 46.6768 4.74987 46.6597 4.71855 46.6357C4.68722 46.6117 4.66123 46.5815 4.64223 46.5469L2.27163 42.386C2.25287 42.3536 2.2407 42.3178 2.23582 42.2807C2.23094 42.2436 2.23345 42.2059 2.2432 42.1697C2.25296 42.1336 2.26976 42.0997 2.29265 42.0701C2.31554 42.0405 2.34406 42.0157 2.37658 41.9971L4.15453 40.9847C4.2196 40.9482 4.26772 40.8877 4.28851 40.8161C4.3093 40.7444 4.30109 40.6675 4.26565 40.6019L3.2532 38.6943C3.22042 38.6314 3.21238 38.5585 3.23066 38.4899C3.24894 38.4214 3.29222 38.3622 3.35198 38.3239L5.27192 37.0213C5.32911 36.9824 5.3705 36.9242 5.38861 36.8575C5.40673 36.7907 5.40037 36.7196 5.37069 36.6571L4.36442 34.552C4.33642 34.4901 4.33096 34.4205 4.34901 34.355C4.36705 34.2896 4.40746 34.2326 4.4632 34.1939L6.42018 32.8296C6.47689 32.7917 6.51809 32.7347 6.53622 32.6689C6.55436 32.6032 6.54823 32.5331 6.51895 32.4715L5.32748 30.033C5.30268 29.9695 5.30268 29.899 5.32748 29.8354L7.17951 23.0076C7.20673 22.9018 7.20318 22.7904 7.16928 22.6865C7.13538 22.5826 7.07254 22.4906 6.98813 22.4212C5.39785 21.0643 4.31345 19.2093 3.91132 17.1579C3.50919 15.1065 3.81301 12.9794 4.77334 11.1226C5.73367 9.26578 7.29402 7.78852 9.20056 6.93114C11.1071 6.07376 13.2476 5.88671 15.274 6.40039C17.3003 6.91407 19.0933 8.09825 20.3611 9.76034C21.629 11.4224 22.2972 13.4646 22.257 15.5547C22.2168 17.6447 21.4706 19.6597 20.1397 21.2718C18.8089 22.8839 16.9718 23.9983 14.9272 24.4337C14.824 24.4554 14.7287 24.5048 14.6514 24.5766C14.5742 24.6484 14.518 24.7398 14.4889 24.8411L9.29083 43.8677Z"
          stroke={color}
          strokeWidth="2.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M13.6615 14.698C15.0253 14.698 16.1309 13.5924 16.1309 12.2287C16.1309 10.8649 15.0253 9.75928 13.6615 9.75928C12.2977 9.75928 11.1921 10.8649 11.1921 12.2287C11.1921 13.5924 12.2977 14.698 13.6615 14.698Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M30.7003 12.6671C31.1222 11.464 31.2766 10.1834 31.1527 8.91448C31.0288 7.6456 30.6296 6.41903 29.983 5.32026C29.3364 4.22148 28.4579 3.27697 27.4088 2.55257C26.3597 1.82818 25.1652 1.34131 23.9086 1.12596C22.652 0.910614 21.3636 0.971945 20.1331 1.30568C18.9027 1.63941 17.7598 2.23752 16.7843 3.05829C15.8087 3.87906 15.0239 4.90275 14.4846 6.05797C13.9453 7.21319 13.6644 8.47214 13.6616 9.74705C13.6681 10.1148 13.697 10.4817 13.748 10.8459"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </svg>
    </SvgContainer>
  );
};

HyriaIcon.propTypes = {
  size: PropTypes.string
};

HyriaIcon.defaultProps = defaultSvgIconProps;

export default HyriaIcon;
